import { Constants } from 'app/utility/constants';
import { VehicleModel, VehicleSummaryModel } from 'app/models/dms/vehicle.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralService } from 'app/services/general.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-image-displayer',
    templateUrl: './image-displayer.component.html',
    styleUrls: ['./image-displayer.component.scss'],
    standalone: false
})
export class ImageDisplayerComponent implements OnInit
{

    @Input() src: string;
    @Input() safe: boolean = false;
    @Input() cdn: boolean = false;
    @Input() backgroundStyle: string = '';
    @Input() backgroundImage: boolean = false;
    @Input() relatedVehicle: VehicleSummaryModel = null;
    @Input() largeImage: boolean = false;
    @Input() backgroundPosition: string = 'center';
    @Input() portraitOverlay: string;
    @Input() vehicleId: string;

    @Input() bgImageHeight: string;
    @Input() bgImageWidth: string;
    @Input() bgBorderRadius: string = '5';
    @Input() showPlaceholder: boolean = false;

    @Input() log404Errors: boolean = true;

    @Output() imageLoaded = new EventEmitter<string>();
    base64Image: boolean = false;

    constructor(
        private generalService: GeneralService,
        private sanitizer: DomSanitizer) { }

    ngOnInit()
    {
        if (this.src && this.src.startsWith("https:") && !this.src.startsWith(Constants.ApiUrl))
        {
            this.safe = true;
            this.cdn = true;
        }
    }

    bindedHref: string;
    bindedBgStyle: any;
    bindedOverlayStyle: any;

    imageLoading: boolean = false;
    imageLoadComplete: boolean = false;

    ngOnChanges(changes: SimpleChanges)
    {
        if (!this.imageLoadComplete && !this.imageLoading)
        {
            this.loadImage();
        }
    }
    placeholder: boolean = false;
    private loadImage(): void
    {
        if (this.imageLoading) return; //stop infinite loading
        this.imageLoading = true;

        if (this.src && !this.src.startsWith(Constants.ApiUrl) && this.src != Constants.PlaceholderCarUrl)
        {
            this.safe = true;
        }
        if (this.src == Constants.PlaceholderCarUrl)
        {
            this.placeholder = true;
            this.cdn = false;
            this.backgroundImage = true;
        }
        else if (!this.src)
        {
            if (this.vehicleId)
            {
                if (this.vehicleId == Constants.EmptyGuid)
                {
                    this.src = Constants.PlaceholderCarUrl;
                    this.placeholder = true;
                    this.cdn = false;
                }
                else
                {
                    this.src = Constants.ApiUrl + "Vehicles/" + this.vehicleId + "/Thumbnail";
                    this.placeholder = false;
                    this.cdn = false;
                }
            }
        }

        if (this.src.startsWith("data:"))
        {
            this.base64Image = true;
        }
        if (this.safe)
        {
            this.imageLoading = false;
            this.imageLoadComplete = true;
            if (this.src == "noimage.jpg")
            {
                this.placeholder = true;
                this.src = Constants.PlaceholderCarUrl
            }
            this.bindedBgStyle = {
                'background': 'url(\'' + this.src + '\'), url(\'' + Constants.PlaceholderCarUrl + '\'),' + (this.backgroundStyle != null ? this.backgroundStyle : '') + ', var(--ion-color-secondary)',
                'background-size': 'cover, cover',
                'background-repeat': 'no-repeat',
                'background-position': 'center'
            }
        }
        else
        {
            // console.log(this.src);
            // Get the image from the service to allow JWT token to be attached
            let sub = this.generalService.getImage(this.src)
                .subscribe({ next: data =>
                {
                    if (this.showPlaceholder)
                    {
                        var reader = new FileReader();
                        var self = this;
                        reader.onload = function ()
                        {
                            // console.log(reader.result);

                            if (reader.result == "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEQAACxEBf2RfkQAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNAay06AAAAA2SURBVDhPpcixEQAgAAMh9186LkDhnwUNZ9sXZsEsmAWzYBbMglkwC2bBLJgFs2AWzIL5bucCxa39H+iOy+4AAAAASUVORK5CYII=")
                            {

                                self.bindedBgStyle = {
                                    background: 'url(\'' + Constants.PlaceholderCarUrl + '\') ' + (self.backgroundStyle != null ? self.backgroundStyle : '') + ''
                                }
                                self.placeholder = true;
                            }
                            else
                            {
                                self.createImageFromBlob(data);
                            }
                            self.imageLoading = false;
                            self.imageLoadComplete = true;
                        }
                        reader.readAsDataURL(data);
                    }
                    else
                    {
                        this.createImageFromBlob(data);
                        this.imageLoading = false;
                        this.imageLoadComplete = true;
                        this.imageLoaded.emit(this.bindedHref);
                        this.placeholder = false;
                    }
                    if (sub) sub.unsubscribe();

                }, error: error =>
                {
                    this.imageLoading = false;
                    this.imageLoadComplete = true;
                    this.placeholder = true;
                    this.src = Constants.PlaceholderCarUrl;
                    //check if the error is a 404
					if (error instanceof HttpErrorResponse)
                        {
                            switch (error.status)
                            {
                                case 404:
                                    if (this.log404Errors) {
                                        console.error(`${error.statusText}: ${error.message}`);
                                    }
                                    break;
                                default:
                                    console.error(`${error.statusText}: ${error.message}`);
                                    break;
                            }
                        }
                    if (sub) sub.unsubscribe();
                }});
        }

    }

    createImageFromBlob(image: Blob)
    {
        let url = URL.createObjectURL(image);
        this.bindedHref = url;

        if (this.backgroundImage && url)
        {
            this.bindedBgStyle = {
                background: 'url(\'' + url + '\') ' + (this.backgroundStyle != null ? this.backgroundStyle : '') + ', #a3a3a3'
            }
        }
        else
        {
            this.bindedBgStyle = {
            }
        }

    }

    getSafeSrc(url: string)
    {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}
